import React from "react";
import AboutCard from "./aboutCard";
import Work from '../../Images/New/Whay_us/Work.svg'
import Wallet from '../../Images/New/Whay_us/Wallet.svg'
import Check from '../../Images/New/Whay_us/person_check.svg'
import Bounding from '../../Images/New/Whay_us/person_bounding.svg'
import Time from '../../Images/New/Whay_us/time.svg'
import Video from '../../Images/New/Whay_us/video_1.svg'

const About = () => {
  const data = [
    {
      title: "Simplified workflow",
      disc: "Our software offers a Comprehensive Dashboard for an all-in-one view, simplifying your workflow with an intuitive interface.",
      icon: Work,
    },
    {
      title: "Affordable Price",
      disc: "Affordable, powerful software for Chartered Accountants, delivering great value without compromise.",
      icon: Wallet,
    },
    {
      title: "Trusted by Professionals",
      disc: "Our products are trusted across industries, built on our commitment to quality and customer satisfaction.",
      icon: Check,
    },
    {
      title: "Intuitive User Interface",
      disc: "EasyGST’s user-friendly interface simplifies complex tasks, enhancing productivity and ease of use.",
      icon: Bounding,
    },
    {
      title: "Timely Service",
      disc: "We ensure prompt support and updates, keeping your operations running smoothly.",
      icon: Time,
    },
    {
      title: "Trial Version",
      disc: "Experience our software’s full capabilities with a no-cost trial to see how it fits your needs.",
      icon: Video,
    },
  ];

  return (
    <div className="relative z-40 bg-white w-full">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-gray-900">
            Why use <span className="text-[#519980]">EasyGST</span> software
          </h2>
          <p className="mt-2 text-2xl text-gray-600 italic">
            Simplify GST Return filing & Reconciliation with EasyGST Software
          </p>
        </div>
        <div className="mt-12 space-y-10 sm:space-y-0 sm:grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {data.map((item, index) => (
            <AboutCard
              key={index}
              icon={item.icon}
              title={item.title}
              disc={item.disc}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
